import { pluralizeWithCount } from "@common/helpers/string";
import { ScheduleReviewConfirmActionBar } from "./ScheduleReviewConfirmActionBar";

interface RecognitionReviewTaskActionBarProps {
    periodLabel: string;
    selectedCount: number;
    totalCount: number;
    isBusy: boolean;
    onConfirmSelected: () => void;
    onConfirmAll: () => void;
}

export const RecognitionReviewTaskActionBar = ({
    periodLabel,
    selectedCount,
    totalCount,
    isBusy,
    onConfirmSelected,
    onConfirmAll,
}: RecognitionReviewTaskActionBarProps) => {
    if (totalCount === 0) {
        return null;
    }

    return (
        <ScheduleReviewConfirmActionBar
            selectedCount={selectedCount}
            totalCount={totalCount}
            isBusy={isBusy}
            confirmAllLabel="Confirm all"
            confirmAllHotkeyDescription="Confirm all recognition periods"
            confirmAllModal={{
                title: `Post ${pluralizeWithCount("recognition entry", totalCount)} for ${periodLabel}?`,
                question:
                    "Each pending period posts its recognition journal entry. Locked periods are skipped and stay pending.",
                yes: "Post",
            }}
            onConfirmSelected={onConfirmSelected}
            onConfirmAll={onConfirmAll}
        />
    );
};
